import React from 'react';

import { Button } from '@/components/ui/button';

interface CreateWorkActivityFooterProps {
  activeStep: number;
  onPrevClick: () => void;
  onNextClick: () => void;
  loading?: boolean;
  finishLabel?: string;
  loadingLabel?: string;
  amountLabel?: React.ReactNode;
}

const CreateWorkActivityFooter: React.FC<CreateWorkActivityFooterProps> = ({
  activeStep,
  onPrevClick,
  onNextClick,
  loading = false,
  finishLabel = 'Finish',
  loadingLabel = 'Submitting...',
  amountLabel
}) => {
  const isFirstStep = activeStep === 1;
  const isLastStep = activeStep === 3;

  return (
    <footer className="flex flex-col-reverse md:flex-row md:items-center md:justify-between md:pl-4 gap-4">
      {amountLabel ? <div className="w-full md:w-auto">{amountLabel}</div> : <div className="hidden md:block" />}

      <div className="flex justify-end gap-4">
        <Button
          type="button"
          disabled={loading}
          variant="text"
          className="text-[#E8507E] font-semibold text-lg"
          onClick={onPrevClick}
        >
          {isFirstStep ? 'Cancel' : 'Previous'}
        </Button>

        <Button
          className="font-semibold text-base rounded-[24px] h-[44px] w-fit"
          type="button"
          onClick={onNextClick}
          disabled={loading}
        >
          {isLastStep ? (loading ? loadingLabel : finishLabel) : 'Next'}
        </Button>
      </div>
    </footer>
  );
};

export default CreateWorkActivityFooter;
